import React, { useEffect, useRef } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { srConfig } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledAboutSection = styled.section`
  max-width: 900px;

  .inner {
    display: grid;
    grid-template-columns: 3fr 2fr;
    grid-gap: 50px;

    @media (max-width: 768px) {
      display: block;
    }
  }
`;
const StyledText = styled.div`
  ul.skills-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(140px, 200px));
    grid-gap: 0 10px;
    padding: 0;
    margin: 20px 0 0 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      margin-bottom: 10px;
      padding-left: 20px;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        content: '▹';
        position: absolute;
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
  .learning-list {
    margin-top: 20px;
  }
`;
const StyledPic = styled.div`
  position: relative;
  max-width: 300px;

  @media (max-width: 768px) {
    margin: 50px auto 0;
    width: 70%;
  }

  .wrapper {
    ${({ theme }) => theme.mixins.boxShadow};
    display: block;
    position: relative;
    width: 100%;
    border-radius: var(--border-radius);
    background-color: var(--green);

    &:hover,
    &:focus {
      outline: 0;
      transform: translate(-4px, -4px);

      &:after {
        transform: translate(8px, 8px);
      }

      .img {
        filter: none;
        mix-blend-mode: normal;
      }
    }

    .img {
      position: relative;
      border-radius: var(--border-radius);
      mix-blend-mode: multiply;
      filter: grayscale(100%) contrast(1);
      transition: var(--transition);
    }

    &:before,
    &:after {
      content: '';
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: var(--border-radius);
      transition: var(--transition);
    }

    &:before {
      top: 0;
      left: 0;
      background-color: var(--navy);
      mix-blend-mode: screen;
    }

    &:after {
      border: 2px solid var(--green);
      top: 14px;
      left: 14px;
      z-index: -1;
    }
  }
`;

const About = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  const skills = [
    'PHP',
    'WordPress',
    'Laravel',
    'Vue.js',
    'Nuxt.js',
    'Alpine.js',
    'PHPUnit Test',
    'HTML & (S)CSS',
    'JavaScript',
    'jQuery',
    'MySQL',
    'WP GraphQL',
    'Gulp',
    'Webpack',
    'Git',
    'SVN',
  ];

  const learning = ['CodeIgniter', 'React.js', 'Gatsby', 'devOps'];

  return (
    <StyledAboutSection id="about" ref={revealContainer}>
      <h2 className="numbered-heading">About Me</h2>

      <div className="inner">
        <StyledText>
          <div>
            <p>
              I am a software developer from Dhaka, Bangladesh.
            </p>
            <p>
              I enjoy creating things that live on the Internet, such as websites and web applications. I have extensive experience and knowledge in developing efficient and modern <strong>back-end</strong>, making me a <strong>backend-focus</strong> developer. Additionally, I have a solid understanding of <strong>front-end</strong> development, allowing me to create a user-friendly and responsive front-end. My expertise in both areas enables me to build comprehensive and well-rounded applications.
            </p>
            {/* <p>
              I enjoy creating things that live on the Internet, such as websites and web
              applications. I am a <strong>backend-friendly</strong> developer with extensive experience and knowledge in developing efficient and modern back-ends. Additionally, I have a solid understanding of <strong>front-end</strong> development, allowing me to create user-friendly and responsive front-ends. My expertise in both areas enables me to build comprehensive and well-rounded applications.
            </p> */}
            <p>
              I graduated from{' '}
              <a
                href="https://www.easternuni.edu.bd/"
                title="Eastern University"
                rel="noopener noreferrer"
                target="_blank">
                Eastern University
              </a>{' '}
              with a degree in Computer Science & Engineering, and I followed my passion for web
              development and joined{' '}
              <a
                href="https://happymonster.dev/"
                title="HappyMonster"
                rel="noopener noreferrer"
                target="_blank">
                HappyMonster
              </a>
              {', formerly '}
              <a
                href="https://themebucket.net/"
                title="ThemeBucket"
                rel="noopener noreferrer"
                target="_blank">
                ThemeBucket
              </a>
              , as a developer. There, I work on some very interesting projects that challenge me
              and help me grow.
            </p>
            {/* <p>
              Although my specialty is{' '}
              <span className="brand-text">Computer Science &amp; Engineering</span>, I pursued my
              dream and my passion to be a web developer. Here I am today!
            </p> */}
            <p>Here are a few technologies I've been working with recently:</p>
          </div>

          <ul className="skills-list">
            {skills && skills.map((skill, i) => <li key={i}>{skill}</li>)}
          </ul>
          <div className="learning-list">
            <p>I'm also learning these:</p>
          </div>
          <ul className="skills-list">
            {learning && learning.map((skill, i) => <li key={i}>{skill}</li>)}
          </ul>
        </StyledText>

        <StyledPic>
          <div className="wrapper">
            <StaticImage
              className="img"
              src="../../images/me.jpg"
              width={500}
              quality={95}
              formats={['AUTO', 'WEBP', 'AVIF']}
              alt="Headshot"
            />
          </div>
        </StyledPic>
      </div>
    </StyledAboutSection>
  );
};

export default About;
